import Image from '@admin/components/image'
import PropTypes from 'prop-types'
import React from 'react'

const SocialCampaignCard = ({ resource }) => (
  <div className="maha-card-layout-card-body">
    <div className="maha-card-layout-card-screenshot">
      <Image src={ resource.thumbnail?.path || `/${resource.asset?.preview}` } title={ resource.title } transforms={{ w: 250, h: 250, fit: 'cover' }} width={ 250 } height={ 250 } />
    </div>
    <div className="maha-card-layout-card-details">
      <div className="token-stats">
        { resource.type === 'document' ? 'Document' : 'Canva Design' }<br />
        <span>{ resource.description }</span>
      </div>
    </div>
  </div>
)

SocialCampaignCard.propTypes = {
  resource: PropTypes.object
}

export default SocialCampaignCard
